import { inject, injectable } from 'inversify';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserSelectionLocalStorageService } from '@client/entity/current-client-user/data/service/current-client-user-selection.local-storage-service';
import type { CurrentClientUserSelectionRepositoryInterface } from '@client/entity/current-client-user/domain/repository/current-client-user-selection.repository';
import { CurrentClientUserSelection } from '@client/entity/current-client-user/domain/model/current-client-user-selection.model';

@injectable()
export class CurrentClientUserSelectionRepository implements CurrentClientUserSelectionRepositoryInterface {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserSelectionLocalStorageService)
    private readonly localStorageService: CurrentClientUserSelectionLocalStorageService,
  ) {}

  public saveSelection(selection: CurrentClientUserSelection): void {
    this.localStorageService.saveSelectedClientId(selection.clientId);
  }

  public getSelection(): CurrentClientUserSelection | null {
    const clientId = this.localStorageService.getSelectedClientId();

    return clientId ? new CurrentClientUserSelection(clientId) : null;
  }

  public clearSelection(): void {
    this.localStorageService.clearSelectedClientId();
  }
}
